<template>
  <v-app>
    <router-view/>
    <div class="logo ma-6 ma-md-8 ma-lg-10 ma-xl-12">
      <AppLogo />
    </div>
  </v-app>
</template>

<script>
import AppLogo from "@/components/AppLogo";
export default {
  components: {AppLogo}
}
</script>

<style lang="scss">
html, body {
  background-color: #0f2319;
  height: 100vh;
  overflow: hidden;
}
#app {
  font-family: Carloschi, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  height: 100%;
  /*overflow: hidden;*/
  width: 100vw;
}
#app .logo {
  position: absolute;
  top: 0;
  right: 0;
  height: 10vh;
  /*max-width: 100px;*/
  svg {
    width: 100%;
    height: 100%;
  }
}
</style>